import { create } from "@bufbuild/protobuf";
import { createConnectQueryKey, useQuery, UseQueryOptions } from "@connectrpc/connect-query";

import {
  GetCurrentUserRequest,
  GetCurrentUserRequestSchema,
  GetCurrentUserResponse,
  GetUserRequest,
  GetUserRequestSchema,
  GetUserResponse,
  GetUserTenantsRequest,
  GetUserTenantsRequestSchema,
  GetUserTenantsResponse,
} from "@gx/ts-contracts/services/management/api/user_pb";
import {
  getCurrentUser,
  getUser,
  getUserTenants,
} from "@gx/ts-contracts/services/management/api/user-UserService_connectquery";

// ========== GET CURRENT USER ==========

export const createGetCurrentUserQueryKey = (input?: GetCurrentUserRequest) => {
  return createConnectQueryKey({
    schema: getCurrentUser,
    input,
    cardinality: "finite",
  });
};

export const useGetCurrentUserQuery = ({
  input = create(GetCurrentUserRequestSchema, {}),
  options = {},
}: {
  input?: GetCurrentUserRequest;
  options?: UseQueryOptions<typeof getCurrentUser.output, GetCurrentUserResponse>;
}) => {
  return useQuery<typeof getCurrentUser.input, typeof getCurrentUser.output>(
    getCurrentUser,
    input,
    options,
  );
};

// ========== GET USER ==========

export const createGetUserQueryKey = (input?: GetUserRequest) => {
  return createConnectQueryKey({
    schema: getUser,
    input,
    cardinality: "finite",
  });
};

export const useGetUserQuery = ({
  input = create(GetUserRequestSchema, {}),
  options = {},
}: {
  input?: GetUserRequest;
  options?: UseQueryOptions<typeof getUser.output, GetUserResponse>;
}) => {
  return useQuery<typeof getUser.input, typeof getUser.output>(getUser, input, options);
};

// ========== GET USER TENANTS ==========

export const createGetUserTenantsQueryKey = (input?: GetUserTenantsRequest) => {
  return createConnectQueryKey({
    schema: getUserTenants,
    input,
    cardinality: "finite",
  });
};

export const useGetUserTenantsQuery = ({
  input = create(GetUserTenantsRequestSchema, {}),
  options = {},
}: {
  input?: GetUserTenantsRequest;
  options?: UseQueryOptions<typeof getUserTenants.output, GetUserTenantsResponse>;
}) => {
  return useQuery<typeof getUserTenants.input, typeof getUserTenants.output>(
    getUserTenants,
    input,
    options,
  );
};
